export const STATUS_LIST = [
  { key: "PENDING", label: "Pending", defaultColor: "#6B7280" },
  { key: "IN_PROGRESS", label: "In Progress", defaultColor: "#F59E0B" },
  { key: "SUBMITTED", label: "Submitted", defaultColor: "#8B5CF6" },
  { key: "DONE", label: "Done", defaultColor: "#10B981" },
  { key: "RETURNED", label: "Returned", defaultColor: "#F97316" },
  { key: "REJECTED", label: "Rejected", defaultColor: "#EF4444" },
  { key: "REASSIGNED", label: "Reassigned", defaultColor: "#9CA3AF" },
  { key: "REMOVED", label: "Removed", defaultColor: "#6B7280" },
  { key: "SKIPPED", label: "Skipped", defaultColor: "#D1D5DB" },
  { key: "OVERDUE", label: "Overdue", defaultColor: "#DC2626" },
];

export const DEFAULT_STATUS_COLORS = Object.fromEntries(
  STATUS_LIST.map(({ key, defaultColor }) => [key, defaultColor]),
);

export function resolveStatusColors(tenantConfig) {
  if (!tenantConfig || typeof tenantConfig !== "object") {
    return { ...DEFAULT_STATUS_COLORS };
  }
  return { ...DEFAULT_STATUS_COLORS, ...tenantConfig };
}

export function hexToRgba(hex, alpha) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return `rgba(107,114,128,${alpha})`;
  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function getStatusStyle(status, resolvedColors) {
  const color =
    resolvedColors?.[status] ?? DEFAULT_STATUS_COLORS[status] ?? "#6B7280";
  return {
    borderColor: color,
    backgroundColor: hexToRgba(color, 0.15),
    textColor: color,
    rawColor: color,
  };
}

export function getEffectiveStatus(status, slaPercentage) {
  if (status === "OVERDUE") return "OVERDUE";
  if (
    (status === "IN_PROGRESS" || status === "PENDING") &&
    typeof slaPercentage === "number" &&
    slaPercentage > 100
  ) {
    return "OVERDUE";
  }
  return status;
}
